const proxyUrl = 'https://immense-plateau-07127.herokuapp.com/';

export const SERVER_URL = 'http://dashboard.fallingstar.com/minidash/';
export const DASH_URL = 'http://dashboard.fallingstar.com/dash/img.jpg?path=';

export const API_BASEURL = proxyUrl + SERVER_URL;
export const LOCAL_DATA_PATH = './';

export const POLL_INTERVAL = 30000;
